'use strict';

/* ============================================================
   Skinner & Vale — Theme JS
============================================================ */

/* ---- Initial-load page loader (first session visit only) ---- */
(function () {
  const loader = document.getElementById('page-loader');
  if (!loader) return;
  // Skip loader if already shown this session
  try {
    if (sessionStorage.getItem('sv_loader_shown')) {
      document.body.classList.add('no-loader');
      return;
    }
    sessionStorage.setItem('sv_loader_shown', '1');
  } catch (e) { /* sessionStorage blocked → still show once */ }

  function hideLoader() {
    loader.classList.add('is-hidden');
    setTimeout(() => loader.parentNode && loader.parentNode.removeChild(loader), 600);
  }
  // Hide on load OR after 1500ms ceiling, whichever comes first
  if (document.readyState === 'complete') {
    setTimeout(hideLoader, 350);
  } else {
    window.addEventListener('load', () => setTimeout(hideLoader, 250));
    setTimeout(hideLoader, 1500); // ceiling
  }
})();

/* ---- Mobile tap ripple — touch-only feedback affordance ---- */
(function () {
  if (!matchMedia || !matchMedia('(hover: none)').matches) return;
  const SELECTOR = '.btn, .pdp-atc-btn, .header-icon-btn, .collection-card, .bespoke-service-card, .product-card, .lifestyle-card';
  document.addEventListener('touchstart', function (e) {
    const target = e.target.closest(SELECTOR);
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const touch = e.touches[0];
    const size = Math.max(rect.width, rect.height) * 1.4;
    const ripple = document.createElement('span');
    ripple.className = 'tap-ripple';
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (touch.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (touch.clientY - rect.top - size / 2) + 'px';
    target.appendChild(ripple);
    setTimeout(() => ripple.parentNode && ripple.parentNode.removeChild(ripple), 600);
  }, { passive: true });
})();

/* ---- Premium Follower Cursor ---- */
(function () {
  // Skip on touch devices or browsers without hover capability
  if (window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches) return;

  const dot = document.createElement('div');
  dot.className = 'cursor-dot';
  document.body.appendChild(dot);

  const ring = document.createElement('div');
  ring.className = 'cursor-ring';
  document.body.appendChild(ring);

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let ringX = mouseX;
  let ringY = mouseY;
  let dotX = mouseX;
  let dotY = mouseY;
  
  let isVisible = false;

  document.addEventListener('mousemove', function (e) {
    if (!isVisible) {
      dot.style.opacity = '1';
      ring.style.opacity = '1';
      isVisible = true;
    }
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // Physics-based rendering loop
  function render() {
    // Dot tracks instantly (1.0 lerp factor)
    dotX += (mouseX - dotX) * 1;
    dotY += (mouseY - dotY) * 1;
    
    // Ring tracks with premium lag (0.15 lerp factor)
    ringX += (mouseX - ringX) * 0.15;
    ringY += (mouseY - ringY) * 0.15;
    
    dot.style.transform = `translate(${dotX}px, ${dotY}px)`;
    ring.style.transform = `translate(${ringX}px, ${ringY}px)`;
    
    requestAnimationFrame(render);
  }
  requestAnimationFrame(render);

  // High-end hover states: hide the dot, expand and fade the ring
  const hoverTargets = 'a, button, input, select, textarea, .product-card, .blog-card, .col-switcher-btn, label, [role="button"], summary';

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest(hoverTargets)) {
      dot.classList.add('is-hovering');
      ring.classList.add('is-hovering');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest(hoverTargets)) {
      dot.classList.remove('is-hovering');
      ring.classList.remove('is-hovering');
    }
  });

  // Hide when leaving window viewport
  document.addEventListener('mouseleave', function () {
    dot.style.opacity = '0';
    ring.style.opacity = '0';
    isVisible = false;
  });
  
  document.addEventListener('mouseenter', function () {
    dot.style.opacity = '1';
    ring.style.opacity = '1';
    isVisible = true;
  });
})();


/* ---- Mobile Menu ---- */
const menuToggle  = document.getElementById('menu-toggle');
const menuClose   = document.getElementById('menu-close');
const mobileMenu  = document.getElementById('mobile-menu');
const menuOverlay = document.getElementById('menu-overlay');

function openMenu() {
  mobileMenu.classList.add('open');
  menuOverlay.classList.add('open');
  menuOverlay.removeAttribute('aria-hidden');
  menuToggle.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  mobileMenu.classList.remove('open');
  menuOverlay.classList.remove('open');
  menuOverlay.setAttribute('aria-hidden', 'true');
  menuToggle.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}

menuToggle  && menuToggle.addEventListener('click', openMenu);
menuClose   && menuClose.addEventListener('click', closeMenu);
menuOverlay && menuOverlay.addEventListener('click', closeMenu);
document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMenu(); closeCart(); closeSearch(); closeAllNavDropdowns(); } });

/* ---- Generic Nav Dropdowns (future-proofing) ---- */
function closeAllNavDropdowns() {
  document.querySelectorAll('.nav-dropdown.is-open').forEach(dropdown => {
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');
    const toggleId = dropdown.id;
    if (toggleId) {
      const toggleBtn = document.querySelector(`[aria-controls="${toggleId}"]`);
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });
}

document.querySelectorAll('.nav-toggle-btn').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    const dropdownId = this.getAttribute('aria-controls');
    if (!dropdownId) return;
    const dropdown = document.getElementById(dropdownId);
    if (!dropdown) return;

    const isOpen = dropdown.classList.contains('is-open');
    closeAllNavDropdowns(); // Close others

    if (!isOpen) {
      dropdown.classList.add('is-open');
      dropdown.setAttribute('aria-hidden', 'false');
      this.setAttribute('aria-expanded', 'true');
    }
  });
});

/* Click anywhere outside open dropdowns closes them */
document.addEventListener('click', function(e) {
  if (!e.target.closest('.nav-toggle-wrap')) {
    closeAllNavDropdowns();
  }
});

/* ---- Search Overlay ---- */
const searchToggle  = document.getElementById('search-toggle');
const searchClose   = document.getElementById('search-close');
const searchOverlay = document.getElementById('search-overlay');
const searchInput   = document.getElementById('search-input');

function openSearch() {
  if (!searchOverlay) return;
  searchOverlay.classList.add('open');
  searchOverlay.removeAttribute('aria-hidden');
  searchToggle && searchToggle.setAttribute('aria-expanded', 'true');
  /* No scroll lock — page below the half-screen overlay remains scrollable */
  setTimeout(() => { searchInput && searchInput.focus(); }, 60);
}
function closeSearch() {
  if (!searchOverlay) return;
  searchOverlay.classList.remove('open');
  searchOverlay.setAttribute('aria-hidden', 'true');
  searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
}

searchToggle && searchToggle.addEventListener('click', openSearch);
searchClose  && searchClose.addEventListener('click', closeSearch);
/* Click on the dark backdrop (outside the inner panel) also closes */
searchOverlay && searchOverlay.addEventListener('click', function(e) {
  if (e.target === searchOverlay) closeSearch();
});
/* Click anywhere outside the search overlay closes it */
document.addEventListener('click', function(e) {
  if (!searchOverlay || !searchOverlay.classList.contains('open')) return;
  if (!searchOverlay.contains(e.target) && !(searchToggle && searchToggle.contains(e.target))) {
    closeSearch();
  }
});

/* ---- Live predictive search results ---- */
(function () {
  const input = document.getElementById('search-input');
  const resultsEl = document.getElementById('search-results');
  if (!input || !resultsEl) return;

  const fmtMoney = (cents) => '£' + (cents / 100).toFixed(2);
  let debounceTimer = null;
  let lastQuery = '';
  let abortCtrl = null;

  function setLoading() {
    resultsEl.hidden = false;
    resultsEl.innerHTML = '<div class="search-results-status">Searching…</div>';
  }
  function setEmpty(q) {
    resultsEl.innerHTML =
      '<div class="search-results-status">No results for "' + escapeHtml(q) + '". <a href="/search?q=' + encodeURIComponent(q) + '">Try the full search →</a></div>';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function render(data, q) {
    const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) { setEmpty(q); return; }
    const html = [
      '<ul class="search-results-list" role="listbox">',
      products.map((p) => {
        const img = p.image || (p.featured_image && p.featured_image.url) || '';
        const price = p.price ? fmtMoney(parseInt(p.price, 10)) : '';
        return (
          '<li class="search-results-item" role="option">' +
            '<a href="' + p.url + '" class="search-results-link">' +
              (img ? '<span class="search-results-thumb"><img src="' + img + '" alt="" loading="lazy"></span>' : '<span class="search-results-thumb search-results-thumb--empty"></span>') +
              '<span class="search-results-meta">' +
                '<span class="search-results-title">' + escapeHtml(p.title) + '</span>' +
                (price ? '<span class="search-results-price">' + price + '</span>' : '') +
              '</span>' +
            '</a>' +
          '</li>'
        );
      }).join(''),
      '</ul>',
      '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-results-viewall">See all results for "' + escapeHtml(q) + '" →</a>'
    ].join('');
    resultsEl.innerHTML = html;
  }

  async function fetchResults(q) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      const res = await fetch(url, { signal: abortCtrl.signal });
      if (!res.ok) return;
      const data = await res.json();
      if (input.value.trim() === q) render(data, q);
    } catch (e) { /* aborted or network error */ }
  }

  input.addEventListener('input', function () {
    const q = this.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;
    if (debounceTimer) clearTimeout(debounceTimer);
    if (q.length < 2) {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      return;
    }
    setLoading();
    debounceTimer = setTimeout(() => fetchResults(q), 180);
  });
})();

/* ---- Predictive Search ---- */
const searchResultsEl = document.getElementById('search-results');
let searchTimer;

// Cart API returns prices in cents (e.g. 111500 = £1,115.00) — divide by 100
function formatMoney(cents, currencyCode) {
  const amount = (parseInt(cents, 10) / 100);
  const symbols = { GBP: '£', USD: '$', EUR: '€', AUD: 'A$', CAD: 'C$' };
  const sym = symbols[currencyCode] || (currencyCode + ' ');
  return sym + amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// suggest.json returns prices as decimal pounds already (e.g. 1150.0 = £1,150.00) — NO division
function formatMoneyDecimal(amount, currencyCode) {
  const symbols = { GBP: '£', USD: '$', EUR: '€', AUD: 'A$', CAD: 'C$' };
  const sym = symbols[currencyCode] || (currencyCode + ' ');
  return sym + parseFloat(amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function thumbUrl(url) {
  if (!url) return '';
  return url.indexOf('?') !== -1 ? url + '&width=300' : url + '?width=300';
}

async function runPredictiveSearch(q) {
  if (!searchResultsEl) return;
  if (!q || q.length < 1) {
    searchResultsEl.hidden = true;
    searchResultsEl.innerHTML = '';
    return;
  }
  try {
    const endpoint = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
    const res = await fetch(endpoint, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) return;
    const data = await res.json();
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (products.length === 0) {
      searchResultsEl.innerHTML = '<p class="search-no-results">No products found</p>';
      searchResultsEl.hidden = false;
      return;
    }

    /* currency_code is not on individual suggest.json product objects —
       read it from Shopify's storefront global instead */
    const currCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';

    const rows = products.map(function(p) {
      const img = p.featured_image && p.featured_image.url
        ? '<img src="' + thumbUrl(p.featured_image.url) + '" alt="' + (p.featured_image.alt || '') + '" loading="lazy">'
        : '';
      const price = formatMoneyDecimal(p.price, currCode);
      return '<a href="' + p.url + '" class="search-result-item">'
        + '<div class="search-result-thumb">' + img + '</div>'
        + '<div class="search-result-info">'
        + '<span class="search-result-name">' + p.title + '</span>'
        + '<span class="search-result-price">' + price + '</span>'
        + '</div>'
        + '</a>';
    }).join('');

    const viewAll = '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="search-view-all">'
      + 'View all results'
      + '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
      + '</a>';

    searchResultsEl.innerHTML = rows + viewAll;
    searchResultsEl.hidden = false;
  } catch(err) {
    /* silent — network error or JSON parse failure */
  }
}

if (searchInput) {
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function() { runPredictiveSearch(searchInput.value.trim()); }, 280);
  });
}

/* Clear results when search closes */
const _origCloseSearch = closeSearch;
closeSearch = function() {
  _origCloseSearch();
  if (searchResultsEl) { searchResultsEl.hidden = true; searchResultsEl.innerHTML = ''; }
  if (searchInput) searchInput.value = '';
};

/* ---- Cart Drawer ---- */
const cartToggle       = document.getElementById('cart-toggle');
const cartClose        = document.getElementById('cart-close');
const cartDrawer       = document.getElementById('cart-drawer');
const cartOverlay      = document.getElementById('cart-overlay');
const cartCount        = document.getElementById('cart-count');
const cartBody         = document.getElementById('cart-body');
const cartFooter       = document.getElementById('cart-footer');
const cartTotalDisplay = document.getElementById('cart-total-display');
const cartCheckoutBtn  = document.getElementById('cart-checkout-btn');
const cartLoading      = document.getElementById('cart-loading');

function openCart() {
  cartDrawer && cartDrawer.classList.add('is-open');
  cartOverlay && cartOverlay.classList.add('is-open');
  cartOverlay && cartOverlay.removeAttribute('aria-hidden');
  document.body.style.overflow = 'hidden';
  renderCart();
}
function closeCart() {
  cartDrawer && cartDrawer.classList.remove('is-open');
  cartOverlay && cartOverlay.classList.remove('is-open');
  cartOverlay && cartOverlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

cartToggle  && cartToggle.addEventListener('click', openCart);
cartClose   && cartClose.addEventListener('click', closeCart);
cartOverlay && cartOverlay.addEventListener('click', closeCart);

/* ---- Cart AJAX helpers ---- */
async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    return await res.json();
  } catch (e) {
    return null;
  }
}

async function addToCart(variantId, quantity) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });
    const data = await res.json();
    if (res.ok) bumpCartIcon();
    return data;
  } catch (e) {
    return null;
  }
}

// Tactile feedback: scale/rotate the cart icon and pulse the count badge
function bumpCartIcon() {
  if (cartToggle) {
    cartToggle.classList.remove('is-bumped');
    void cartToggle.offsetWidth; // restart animation
    cartToggle.classList.add('is-bumped');
    setTimeout(() => cartToggle.classList.remove('is-bumped'), 600);
  }
  if (cartCount) {
    cartCount.classList.remove('is-pulsing');
    void cartCount.offsetWidth;
    cartCount.classList.add('is-pulsing');
    setTimeout(() => cartCount.classList.remove('is-pulsing'), 650);
  }
}

async function updateCartItemQty(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  } catch (e) { /* silent */ }
}

async function renderCart() {
  if (!cartBody) return;
  if (cartLoading) cartLoading.classList.remove('is-hidden');

  const cart = await fetchCart();
  if (cartLoading) cartLoading.classList.add('is-hidden');
  if (!cart) return;

  /* Update count bubble */
  if (cartCount) {
    cartCount.textContent = cart.item_count;
    cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }

  /* Update footer */
  if (cartFooter) cartFooter.classList.toggle('is-hidden', cart.item_count === 0);
  const currCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  if (cartTotalDisplay) cartTotalDisplay.textContent = formatMoney(cart.total_price, currCode);
  if (cartCheckoutBtn) cartCheckoutBtn.textContent = 'Checkout — ' + formatMoney(cart.total_price, currCode);

  /* Build items HTML */
  if (cart.item_count === 0) {
    cartBody.innerHTML = `
      <div class="cart-empty">
        <div class="cart-empty-icon">🛍</div>
        <p>Your cart is empty.<br>Discover something beautiful.</p>
        <a href="/collections/all" class="btn btn-dark">Shop Now</a>
      </div>`;
    return;
  }

  /* 2026-05-13 — Customisation pairing in the drawer.
     Each customiser order is two line items: base jacket (carries 'Design ID')
     + SV-CUSTOM-ADDON (carries '_addon_for_design'). Render the add-on as a
     "Customisations" sub-row under its parent instead of a standalone row
     showing "× 3500". Linked remove takes both items out together so the
     customer can't end up with a £65 customiser-base jacket on its own. */
  function isCustomisationAddon(item) {
    return (item.sku && item.sku.indexOf('SV-CUSTOM-ADDON') !== -1)
      || (item.handle === 'sv-customisation-add-on');
  }
  function findLinkedAddon(jacketItem, allItems) {
    const did = jacketItem.properties && jacketItem.properties['Design ID'];
    if (!did) return null;
    return allItems.find(i => isCustomisationAddon(i) && i.properties && i.properties._addon_for_design === did) || null;
  }
  function safeImg(url, alt) {
    if (!url || typeof url !== 'string' || url === 'null' || url === 'undefined') {
      return '<span class="cart-item-img cart-item-img--placeholder" aria-hidden="true"></span>';
    }
    const safeAlt = String(alt == null ? '' : alt).replace(/"/g, '&quot;');
    return '<img src="' + url + '" alt="' + safeAlt + '" class="cart-item-img" width="80" height="80" loading="lazy" />';
  }

  const itemsHtml = cart.items.map(item => {
    if (isCustomisationAddon(item)) return ''; // skip — rendered as sub-row of parent
    const linkedAddon = findLinkedAddon(item, cart.items);
    // 2026-05-13 (v2): pair jacket + customisation prices into a labeled
    // two-row block inline-flex layout so customer doesn't read £65 and
    // miss the £35 customisation. Both labels left, both prices right.
    // (Standalone non-customised items keep their existing single price row.)
    const jacketPriceLine = linkedAddon
      ? `<p class="cart-item-jacket-base" style="display:flex;justify-content:space-between;align-items:baseline;gap:8px;margin:6px 0 2px;font-size:13px;color:rgba(0,0,0,0.75);"><span>Jacket</span><span>${formatMoney(item.final_line_price, currCode)}</span></p>`
      : '';
    const customisationLine = linkedAddon
      ? `<p class="cart-item-customisation" style="display:flex;justify-content:space-between;align-items:baseline;gap:8px;margin:2px 0 4px;font-size:13px;color:rgba(0,0,0,0.6);"><span>Customisations</span><span>${formatMoney(linkedAddon.final_line_price, currCode)}</span></p>`
      : '';
    // 2026-05-13 (v2): render all 5 angle screenshots as clickable links
    // when available. Sam: "the design preview link only shows one of the
    // five images that is captured." Underscore properties are hidden from
    // checkout but accessible to JS, so we surface them in the drawer/page.
    const props = item.properties || {};
    const angleLinks = [
      { name: 'Front',      url: props._preview_front    },
      { name: 'Back',       url: props._preview_back     },
      { name: 'Left',       url: props._preview_left     },
      { name: 'Right',      url: props._preview_right    },
      { name: 'Collar',     url: props._preview_collar   },
      { name: 'Back Print', url: props._back_image_url   }
    ].filter(a => typeof a.url === 'string' && /^https?:\/\//i.test(a.url));
    let designPreviewLine = '';
    if (angleLinks.length > 0) {
      designPreviewLine = `<div class="cart-item-previews" style="margin:4px 0;font-size:12px;display:flex;flex-wrap:wrap;gap:6px;align-items:center;">
        <span style="color:rgba(0,0,0,0.55);">Design previews:</span>
        ${angleLinks.map(a => `<a href="${a.url}" target="_blank" rel="noopener" style="color:#298a30;text-decoration:underline;">${a.name}↗</a>`).join(' ')}
      </div>`;
    } else {
      // Fallback to legacy single Design Preview URL property
      const designPreviewUrl = props['Design Preview'];
      if (typeof designPreviewUrl === 'string' && /^https?:\/\//i.test(designPreviewUrl)) {
        designPreviewLine = `<p class="cart-item-preview" style="margin:4px 0;font-size:12px;"><a href="${designPreviewUrl}" target="_blank" rel="noopener" style="color:#298a30;text-decoration:underline;">View design preview ↗</a></p>`;
      }
    }
    const linkedAttr = linkedAddon ? `data-linked-addon-key="${linkedAddon.key}"` : '';
    // Customised jackets are unique per design (own badges/studs/screenshots),
    // so qty must stay at 1. Re-customise to order another. Hide +/- buttons
    // when a linked add-on is present.
    const qtyControl = linkedAddon
      ? `<span class="cart-qty-control cart-qty-control--locked" title="Customised orders are unique. Re-customise to order another."><span class="cart-qty-val">${item.quantity}</span></span>`
      : `<div class="cart-qty-control">
            <button class="cart-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease quantity">−</button>
            <span class="cart-qty-val">${item.quantity}</span>
            <button class="cart-qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase quantity">+</button>
          </div>`;
    return `
    <div class="cart-item" data-key="${item.key}" ${linkedAttr}>
      <a href="${item.url}" class="cart-item-img-link">
        ${safeImg(item.image, item.title)}
      </a>
      <div class="cart-item-info">
        <p class="cart-item-title">${item.product_title}</p>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
        ${jacketPriceLine}
        ${customisationLine}
        ${designPreviewLine}
        <div class="cart-item-row">
          ${qtyControl}
          ${linkedAddon ? '' : `<span class="cart-item-price">${formatMoney(item.final_line_price, currCode)}</span>`}
          <button class="cart-remove-btn" data-key="${item.key}" ${linkedAttr} aria-label="Remove ${item.product_title}">✕</button>
        </div>
      </div>
    </div>`;
  }).join('');

  cartBody.innerHTML = itemsHtml;

  /* Qty controls */
  cartBody.querySelectorAll('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', async function() {
      const key = this.dataset.key;
      const delta = parseInt(this.dataset.delta);
      const item = cart.items.find(i => i.key === key);
      if (!item) return;
      const newQty = Math.max(0, item.quantity + delta);
      await updateCartItemQty(key, newQty);
      renderCart();
    });
  });

  /* Remove — if a linked add-on exists, take both out atomically */
  cartBody.querySelectorAll('.cart-remove-btn').forEach(btn => {
    btn.addEventListener('click', async function() {
      const jacketKey = this.dataset.key;
      const linkedKey = this.dataset.linkedAddonKey || null;
      if (linkedKey) {
        await updateCartItemQty(linkedKey, 0);
      }
      await updateCartItemQty(jacketKey, 0);
      renderCart();
    });
  });
}

async function updateCartCount() {
  const cart = await fetchCart();
  if (!cart || !cartCount) return;
  cartCount.textContent = cart.item_count;
  cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
}

/* ---- Quick Add buttons ---- */
document.querySelectorAll('.product-card-quick-add').forEach(btn => {
  btn.addEventListener('click', async function(e) {
    e.preventDefault();
    e.stopPropagation();
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    this.textContent = '...';
    this.disabled = true;
    await addToCart(variantId, 1);
    openCart();
    this.textContent = 'Added ✓';
    setTimeout(() => {
      this.textContent = 'Quick Add';
      this.disabled = false;
    }, 1800);
  });
});

/* ---- Footer locale / country switcher ---- */
(function () {
  const localeForm = document.getElementById('footer-localization-form');
  if (!localeForm) return;

  const localeBtn = localeForm.querySelector('.footer-locale-btn');
  const localeSelect = localeForm.querySelector('select[name="country_code"]');

  if (localeBtn && localeSelect) {
    localeBtn.addEventListener('click', function () {
      localeSelect.focus();
    });
  }

  if (localeSelect) {
    localeSelect.addEventListener('change', function () {
      localeForm.submit();
    });
  }
})();

/* ---- Newsletter form ---- */
const newsletterForm = document.getElementById('newsletter-form');
newsletterForm && newsletterForm.addEventListener('submit', function(e) {
  // Handled natively by Shopify {% form 'customer' %} — no preventDefault needed in production
  const input = this.querySelector('input[type="email"]');
  if (input && !input.value) {
    e.preventDefault();
    input.focus();
  }
});

/* ---- Transparent header — fill in on scroll ---- */
const header = document.getElementById('site-header');
function updateHeader() {
  if (!header) return;
  if (window.scrollY > 40) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}
window.addEventListener('scroll', updateHeader, { passive: true });
updateHeader();

/* ---- Init cart count on page load ---- */
updateCartCount();

/* ---- Hero image load animation ---- */
const heroEl = document.querySelector('[data-hero]');
if (heroEl) {
  const heroImg = heroEl.querySelector('.hero-img');
  if (heroImg && heroImg.complete) {
    heroEl.classList.add('loaded');
  } else if (heroImg) {
    heroImg.addEventListener('load', () => heroEl.classList.add('loaded'));
  }

  /* Reduced motion check for hero video */
  const heroVideo = heroEl.querySelector('.hero-video');
  if (heroVideo) {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.matches) {
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
    }
    // Also listen for changes
    motionQuery.addEventListener('change', (e) => {
      if (e.matches) {
        heroVideo.pause();
      } else {
        heroVideo.play();
      }
    });
  }
}

/* ---- Scroll Reveal (Unified: uses 'is-revealed') ---- */
(function () {
  const REVEALED_CLASS = 'is-revealed';

  // Observe all elements that already have the .reveal class in HTML
  // plus any dynamically targeted elements
  const staticTargets = document.querySelectorAll('.reveal');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(REVEALED_CLASS);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -30px 0px' });

  staticTargets.forEach(el => observer.observe(el));

  // Also observe collection product cards (added dynamically via Liquid stagger)
  document.querySelectorAll('.col-grid .product-card').forEach(el => {
    if (!el.classList.contains('reveal')) {
      el.classList.add('reveal');
    }
    observer.observe(el);
  });

  // Dynamically observe typography and standard page blocks globally
  document.querySelectorAll('.rte > *, .contact-form, .page-width > h1, .shopify-policy__container > *').forEach((el, index) => {
    if (!el.classList.contains('reveal')) {
      el.classList.add('reveal');
      if (index % 3 === 1) el.classList.add('reveal-stagger-1');
      if (index % 3 === 2) el.classList.add('reveal-stagger-2');
    }
    observer.observe(el);
  });
})();

/* ---- Email Capture Pop-up ---- */
(function() {
  var SV_DISMISSED  = 'sv_popup_dismissed'; /* JSON: { ts: <ms>, count: 1|2 } */
  var SV_SUBSCRIBED = 'sv_subscribed';      /* permanent flag once email submitted */
  var SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

  var popupEl      = document.getElementById('email-popup');
  var popupOverlay = document.getElementById('email-popup-overlay');
  var popupClose   = document.getElementById('email-popup-close');
  var popupForm    = document.getElementById('email-popup-form');
  var popupThanks  = document.getElementById('email-popup-thanks');

  if (!popupEl) return;

  /*
   * shouldShow() — dismissal rules:
   *   No entry          → show (first visit)
   *   count 1, < 7 days → suppress (cooling-off period)
   *   count 1, ≥ 7 days → show once more (second and final chance)
   *   count 2           → suppress permanently
   *   sv_subscribed set → suppress permanently (same browser/device)
   */
  function shouldShow() {
    try {
      if (localStorage.getItem(SV_SUBSCRIBED)) return false;
      var raw = localStorage.getItem(SV_DISMISSED);
      if (!raw) return true; /* never seen it */
      var entry = JSON.parse(raw);
      if (entry.count >= 2) return false; /* permanently suppressed */
      if (Date.now() - entry.ts < SEVEN_DAYS_MS) return false; /* within 7-day window */
      return true; /* 7 days have passed — show once more */
    } catch(e) {
      return false; /* localStorage blocked or corrupted — don't show */
    }
  }

  /* recordDismissal() — increments count; count 2 = permanent */
  function recordDismissal() {
    try {
      var raw = localStorage.getItem(SV_DISMISSED);
      var prev = raw ? JSON.parse(raw) : null;
      var count = (prev && prev.count >= 1) ? 2 : 1;
      localStorage.setItem(SV_DISMISSED, JSON.stringify({ ts: Date.now(), count: count }));
    } catch(e) {}
  }

  if (!shouldShow()) return;

  let previouslyFocusedElement = null;

  function openPopup() {
    previouslyFocusedElement = document.activeElement;
    popupEl.classList.add('is-open');
    popupEl.removeAttribute('aria-hidden');

    // Focus trap
    const focusableEls = popupEl.querySelectorAll('button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    const focusableElements = Array.from(focusableEls).filter(el => el.offsetParent !== null);
    if (focusableElements.length) {
      setTimeout(() => focusableElements[0].focus(), 50);
    }
  }

  function closePopup(dismiss) {
    popupEl.classList.remove('is-open');
    popupEl.setAttribute('aria-hidden', 'true');
    if (dismiss) recordDismissal();
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }
  }

  /* Trap tab key inside popup */
  popupEl.addEventListener('keydown', function(e) {
    if (e.key === 'Tab') {
      const focusableEls = popupEl.querySelectorAll('button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      const focusableElements = Array.from(focusableEls).filter(el => el.offsetParent !== null);
      if (focusableElements.length === 0) return;
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  });

  /* Show on whichever fires first: 30s elapsed OR 50% scroll depth.
     Less intrusive than the old 4-second timer — gives visitors time
     to engage with the site before interrupting them. */
  let popupTriggered = false;
  function triggerPopup() {
    if (popupTriggered) return;
    popupTriggered = true;
    openPopup();
  }
  // Time-based trigger
  setTimeout(triggerPopup, 30000);
  // Scroll-depth trigger (50% of scrollable height)
  function checkScroll() {
    if (popupTriggered) return;
    const docH = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight
    );
    const scrolled = window.scrollY + window.innerHeight;
    if (scrolled / docH >= 0.5) {
      triggerPopup();
      window.removeEventListener('scroll', checkScroll);
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });

  /* Exit-intent trigger — desktop only, pointer leaves through the top */
  if (matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function(e) {
      if (popupTriggered) return;
      // Only fire when the mouse actually leaves the viewport from the top
      if (e.relatedTarget == null && e.clientY <= 0) {
        triggerPopup();
      }
    });
  }

  /* Close triggers */
  popupClose   && popupClose.addEventListener('click',   function() { closePopup(true); });
  popupOverlay && popupOverlay.addEventListener('click', function() { closePopup(true); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popupEl.classList.contains('is-open')) closePopup(true);
  });

  /* AJAX form submission */
  if (popupForm) {
    popupForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(popupForm);
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(res) {
        if (res.ok) {
          popupForm.hidden = true;
          if (popupThanks) popupThanks.hidden = false;
          try { localStorage.setItem(SV_SUBSCRIBED, '1'); } catch(e) {}
          setTimeout(function() { closePopup(false); }, 3000); /* don't dismiss — subscribed */
        }
      })
      .catch(function() { /* silent fail — don't block the user */ });
    });
  }
})();
